module.exports = __webpack_public_path__ + "img/bodytalk-logo-flat.7fb3618e.svg";